import React from 'react';
import Row from "@amzn/meridian/esm/components/row";
import Column from "@amzn/meridian/esm/components/column";
import FeedbackCard from "../../common/FeedbackCard";
import WikiCard from "../../common/WikiCard";

/**
 * HelpTabInClient Component
 *
 * Displays the help tab content for the client interface, including FeedbackCard and WikiCard
 * in a structured layout with specific spacing and alignment.
 *
 * @returns {JSX.Element} Help tab content with feedback and wiki cards for the client interface
 */
const HelpTabInClient = () => {
    return (
        <Row spacingInset="none" spacing="none">
            <Row width="74px" />
            <Row width="272px">
                <Column 
                    spacing="none" 
                    heights={["Pixels", "Pixels", "fit%"]} 
                    spacingInset="none" 
                    alignment="top" 
                    alignmentHorizontal="start"
                >
                    <Column height="72px" />
                    <Column height="96px">
                        <FeedbackCard />
                    </Column>
                    <Column height="389px" />
                </Column>
            </Row>
            <Row width="24px" />
            <Row width="272px">
                <Column 
                    spacing="none" 
                    heights={["Pixels", "Pixels", "fit%"]} 
                    spacingInset="none" 
                    alignment="top" 
                    alignmentHorizontal="start"
                >
                    <Column height="72px" />
                    <Column height="96px">
                        <WikiCard />
                    </Column>
                    <Column height="389px" />
                </Column>
            </Row>
        </Row>
    );
};

export default HelpTabInClient;
